// 导入自己需要的组件
import { Popover } from 'element-ui'
const element = {
    install: function (Vue) {
        Vue.use(Popover)
    }
}
export default element
